import { InjectionToken, Provider } from '@angular/core';
import { PaymentsApiService } from '../payments-api.service';
import { PaymentsRepository } from '../payments.repository';

export const HTTP_PAYMENTS_SERVICE = new InjectionToken<PaymentsRepository>('PaymentsRepository');

export const PAYMENTS_API_PROVIDER: Provider = {
    provide: HTTP_PAYMENTS_SERVICE,
    useClass: PaymentsApiService,
};
